import type ScheduledEmail from '@/data/models/domain/ScheduledEmail'
import type { CreateUpdateEmailCampaignRequestFollowUp } from '@/data/repositories/domain/campaign/emailCampaignRepository'
import type { RequireAtLeastOne } from '@/types'

export enum ScheduledEmailStatus {
  New = 'new',
  Paused = 'paused',
  Completed = 'completed',
}

export enum ScheduledEmailType {
  Once = 'once',
  Hourly = 'hourly',
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export enum ScheduledEmailFailedReason {
  LowBalance = 'lowBalance',
  NoRecipients = 'noRecipients',
  NoEmailSender = 'noEmailSender',
  NoPermission = 'noPermission',
}

type ScheduledEmailBulkRequestBodyFilterId = RequireAtLeastOne<{
  in: number[]
  notIn: number[]
}>

interface ScheduledEmailBulkRequestBodyFilter {
  id?: ScheduledEmailBulkRequestBodyFilterId
  status?: RequireAtLeastOne<{
    in: ScheduledEmailStatus[]
    notIn: ScheduledEmailStatus[]
  }>
}

interface ScheduledEmailBulkResendRequestBodyFilter {
  id?: ScheduledEmailBulkRequestBodyFilterId
}

export interface ScheduledEmailBulkDeleteRequestBody {
  filters?: ScheduledEmailBulkRequestBodyFilter[]
}

export interface ScheduledEmailFailedBulkDeleteRequestBody {
  filters?: ScheduledEmailBulkRequestBodyFilter[]
}

export interface ScheduledEmailFailedBulkResendRequestBody {
  filters?: ScheduledEmailBulkResendRequestBodyFilter[]
}

export interface ScheduledEmailBulkPauseRequestBody {
  filters?: ScheduledEmailBulkRequestBodyFilter[]
}

export interface ScheduledEmailBulkResumeRequestBody {
  filters?: ScheduledEmailBulkRequestBodyFilter[]
}

export interface ScheduledEmailFetchRequestBodyFilter {
  status?: RequireAtLeastOne<{
    in: ScheduledEmailStatus[]
    notIn: ScheduledEmailStatus[]
  }>
}

export type ScheduledEmailRecipientsRequest = {
  contactIds: number[]
  groupIds: number[]
  emails: string[]
  filteredViewIds: number[]
  folderIds: number[]
}

export type ScheduledEmailScheduleParams = {
  startDateTime: string
  timezone: string
  rrule?: string
}

export type ScheduledEmailSingleResponse = {
  campaign: ScheduledEmail
  cost: number
}

export type ScheduledEmailUpdateRequest = {
  id: string
  emailSenderId: number
  subject: string
  message: string
  recipients: ScheduledEmailRecipientsRequest
  fromName?: string
  replyToEmail?: string
  fileIds: string[]
  scheduleParams: ScheduledEmailScheduleParams
  followUp?: CreateUpdateEmailCampaignRequestFollowUp
  labelId?: string | null
}

export type ScheduledEmailGetPriceRequest =
  | {
      ids: string[]
    }
  | {
      all: true
    }

export type ScheduledEmailGetPriceResponse = {
  price: number
}
